import { render, staticRenderFns } from "./CardUpdateCardGrid.vue?vue&type=template&id=5397855e&scoped=true&"
import script from "./CardUpdateCardGrid.vue?vue&type=script&lang=js&"
export * from "./CardUpdateCardGrid.vue?vue&type=script&lang=js&"
import style0 from "./CardUpdateCardGrid.vue?vue&type=style&index=0&id=5397855e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5397855e",
  null
  
)

export default component.exports